export const createActionType = (namespace,type) => `${namespace}/${type}`;